import { render } from "./PersonalDetails.vue?vue&type=template&id=dfbfe53a&scoped=true&lang=pug"
import script from "./PersonalDetails.vue?vue&type=script&lang=ts"
export * from "./PersonalDetails.vue?vue&type=script&lang=ts"

import "./PersonalDetails.vue?vue&type=style&index=0&id=dfbfe53a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-dfbfe53a"

export default script